import { render, staticRenderFns } from "./KeysEdit.vue?vue&type=template&id=b064ac8e&scoped=true&"
import script from "./KeysEdit.vue?vue&type=script&lang=ts&"
export * from "./KeysEdit.vue?vue&type=script&lang=ts&"
import style0 from "./KeysEdit.vue?vue&type=style&index=0&id=b064ac8e&lang=scss&scoped=true&"
import style1 from "./KeysEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b064ac8e",
  null
  
)

export default component.exports